export const baseURL = "https://ai-api.projectchef.io/"
// export const baseURL = "http://127.0.0.1:8000/";

export const requestURLs = {
  sentLive: `${baseURL}api/message`,
  getChat: `api/history`,
  getAllChat: `api/threads`,
  getUser: `${baseURL}api/admin/get_or_create_user`,
  getThread: `${baseURL}api/thread`
};
